import { backendUrl } from "@shared/constants/urls/appUrls";

export const performLogout = async (store, router) => {
  try {
    await fetch(`${backendUrl}/api/token/blacklist/`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
    });
  } catch {} // если токен уже невалидный — не страшно
  store.commit('UserSystem/clearUserData');
  await store.dispatch('logout');
  await router.push('/');
};